/** Always-visible small pencil. Replaced the big "Edit metrics"
 *  labeled button per user feedback — the label ate horizontal space
 *  and fought the metric legend next to it. Tooltip carries the
 *  intent. */
export function CustomizeButton({
  active,
  onClick,
}: {
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Configure metrics"
      title="Edit metrics"
      style={{
        width: 24,
        height: 24,
        borderRadius: 6,
        border: `1px solid ${active ? "var(--c-accent-400)" : "var(--c-border)"}`,
        background: active ? "var(--c-accent-50)" : "var(--c-surface)",
        color: active ? "var(--c-accent-700)" : "var(--c-text-3)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        padding: 0,
      }}
    >
      <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
        <path
          d="M11.5 2.5l2 2L5 13H3v-2l8.5-8.5z"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
